import { render, staticRenderFns } from "./MATERIEL_Page.vue?vue&type=template&id=120ace3a&"
import script from "./MATERIEL_Page.vue?vue&type=script&lang=js&"
export * from "./MATERIEL_Page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports